import { useCookies } from 'react-cookie';
import { useParams } from 'react-router-dom';
import { BASE_URLS } from '../constants/globalConstants';

const useUtilities = () => {
  const { roleId } = useParams();
  const [cookies] = useCookies();

  const isSolo = () => {
    return roleId === 'solo-instructor' || roleId === 'solo-client';
  };

  const isSoloInstructor = () => {
    return roleId === 'solo-instructor';
  };
  const isSoloClient = () => {
    return roleId === 'solo-client';
  };
  const isLoggedIn = () => {
    return !!cookies?.token;
  };

  const getBaseUrlForDashboard = () => {
    const currentUrl = window.location.href;
    let dashboardPath = BASE_URLS.prd.dashboardUrl;
    if (currentUrl.indexOf('stg') > -1) {
      dashboardPath = BASE_URLS.stg.dashboardUrl;
    }
    if (currentUrl.indexOf('local') > -1) {
      dashboardPath = BASE_URLS.local.dashboardUrl;
    }
    return dashboardPath;
  };

  return {
    isSolo,
    isSoloInstructor,
    isSoloClient,
    isLoggedIn,
    getBaseUrlForDashboard,
  };
};

export default useUtilities;
